import { Validators } from '../../../../utils/validators';
import { FormModel } from '../../../../components/Form';
import { CountryCode } from 'libphonenumber-js';
export const CustomerDetailsEditForm = (
  strings: any,
  // language: [],
  country: [],
  states: [],
  cities: [],
  company: boolean,
  defaultCountry: CountryCode,
  isCaptureLoyaltyDetails: boolean,
): FormModel[] => {
  let arr = [
    {
      label: strings.customermgmt_text_firstName,
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'firstName',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12, md: 6, lg: 4 },
      required: false,
    },
    {
      label: strings.customermgmt_text_lastName,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'lastName',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12, md: 6, lg: 4 },
      required: false,
    },
    {
      label: strings.customerDetailsEmailId,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'email',
      validators: [{ check: Validators.validateString }, { check: Validators.validateEmail }],
      responsive: { xs: 12, md: 6, lg: 4 },
      required: false,
    },
    {
      label: strings.customermgmt_text_phone,
      value: '',
      size: 'medium',
      type: 'phoneInput',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'phone',
      validators: [{ check: Validators.validateMobile }],
      responsive: { xs: 12, md: 6, lg: 4 },
      required: false,
      defaultCountry: defaultCountry,
    },
    {
      label: strings.customermgmt_text_address,
      value: '',
      size: 'medium',
      type: 'text',
      placeholder: '',
      field: 'address',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12, lg: 8 },
      required: false,
    },
    {
      label: strings.customermgmt_text_pinCode,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'pinCode',
      validators: [{ check: Validators.validatePinCode }],
      responsive: { xs: 12, md: 6, lg: 4 },
      required: false,
    },
    {
      label: strings.customermgmt_text_country,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'country',
      validators: [],
      responsive: { xs: 12, md: 6, lg: 4 },
      required: false,
      options: country,
    },
    {
      label: strings.customermgmt_text_state,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'state',
      validators: [],
      responsive: { xs: 12, md: 6, lg: 4 },
      required: false,
      options: states,
    },
    {
      label: strings.customermgmt_text_city,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'city',
      validators: [],
      responsive: { xs: 12, md: 6, lg: 4 },
      required: false,
      options: cities,
    },
    {
      label: strings.customermgmt_text_gst,
      value: '',
      size: 'medium',
      type: 'text',
      placeholder: '',
      field: 'gst',
      validators: [{ check: Validators.validateString, max: 20 } as any],
      responsive: { xs: 12, md: 6, lg: 4 },
      required: false,
    },
    {
      label: strings.customermgmt_text_panNumber,
      value: '',
      size: 'medium',
      type: 'text',
      placeholder: '',
      field: 'panNumber',
      validators: [{ check: Validators.validateString, max: 10 } as any],
      responsive: { xs: 12, md: 6, lg: 4 },
      required: false,
    },
  ];

  if (company) {
    arr.push(
      {
        label: strings.customermgmt_text_company,
        value: '',
        size: 'medium',
        type: 'text',
        placeholder: '',
        field: 'companyName',
        validators: [{ check: Validators.validateString }],
        responsive: { xs: 12, md: 6, lg: 4 },
        required: false,
        // disabled: true,
      } as any,
      {
        label: strings.customermgmt_text_designation,
        value: '',
        size: 'medium',
        type: 'text',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'designation',
        validators: [{ check: Validators.validateString, max: 50 } as any],
        responsive: { xs: 12, md: 6, lg: 4 },
        required: false,
        // disabled: !company,
      },
    );
  }

  if (isCaptureLoyaltyDetails) {
    arr.push(
      {
        label: strings.LoyaltyProgram,
        value: '',
        size: 'medium',
        autoFocus: false,
        type: 'section',
        typeValue: '',
        variant: '',
        placeholder: '',
        field: '',
        validators: [],
        responsive: { xs: 12, md: 12, lg: 12 },
        required: false,
      },
      {
        label: strings.name,
        value: '',
        size: 'medium',
        autoFocus: false,
        type: 'text',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'loyaltyName',
        validators: [{ check: Validators.validateString }],
        responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: false,
      } as any,
      {
        label: strings.referenceNo,
        value: '',
        size: 'medium',
        autoFocus: false,
        type: 'text',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'loyaltyReferenceNo',
        validators: [{ check: Validators.validateString }],
        responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: false,
      } as any,
      {
        label: strings.remark,
        value: '',
        size: 'medium',
        autoFocus: false,
        type: 'text',
        typeValue: 'text',
        variant: 'outlined',
        placeholder: '',
        field: 'loyaltyRemark',
        validators: [{ check: Validators.validateString }],
        responsive: { xs: 12, sm: 6, md: 4, lg: 3 },
        required: false,
      } as any,
    );
  }

  return arr;
};
